import { GalleryCategories } from '@tovia/man-protos/dist/types/content.types';
import { MetArt, MetArtX, SexArt } from 'src/client/constants/sites';

export type PromoCategoryConfig = {
  assetsAspectRatios: {
    desktop?: number;
    mobile_ver?: number;
    mobile_hor?: number;
    tablet?: number;
  };
  assetsDirectory: string;
  categoryName: string;
  inlineBanner?: boolean;
  sitesToDisplay?: string[];
  sitesToHide?: string[];
  UUID?: string;
  url?: string;
  whitelistedPartnerIDs?: number[];
};

type PromoCategoriesConfig = {
  categories: readonly PromoCategoryConfig[];
  getCategoryConfig: (galleryCategories?: GalleryCategories[]) => PromoCategoryConfig | undefined;
};

export const promoCategoriesConfig: PromoCategoriesConfig = {
  categories: [
    {
      // The URL has to be a redirect since the true link will get caught by adblockers.
      // This category should be applied on these galleries:
      // https://www.metart.com/model/kylie-kennedy/movie/20240314/UNVEILING
      // https://www.metart.com/model/kylie-kennedy/gallery/20240314/UNVEILING
      categoryName: 'playboy-coproduction-set-1',
      url: 'https://www.metart.com/playboy-coproduction-1',
      sitesToDisplay: [MetArt.abbreviation],
      assetsDirectory: 'playboy-coproduction-set-1',
      assetsAspectRatios: {
        desktop: 959 / 140,
        mobile_hor: 620 / 56,
        mobile_ver: 335 / 143,
        tablet: 740 / 152,
      },
    },
    {
      // The URL has to be a redirect since the true link will get caught by adblockers.
      // This category should be applied on these galleries:
      // https://www.metart.com/model/catalina-ossa-and-kylie-kennedy/movie/20240314/PLAYBOY_PLUS_AND_METART__A_CO_PRODUCTION
      // https://www.metart.com/model/kylie-kennedy-and-catalina-ossa/gallery/20240314/PLAYBOY_PLUS_AND_METART__A_CO_PRODUCTION
      categoryName: 'playboy-coproduction-set-2',
      url: 'https://www.metart.com/playboy-coproduction-2',
      sitesToDisplay: [MetArt.abbreviation],
      assetsDirectory: 'playboy-coproduction-set-2',
      assetsAspectRatios: {
        desktop: 959 / 140,
        mobile_hor: 620 / 56,
        mobile_ver: 335 / 143,
        tablet: 740 / 152,
      },
    },
    {
      categoryName: 'playboy-coproduction-set-3',
      url: 'https://www.metart.com/playboy-coproduction-3',
      sitesToDisplay: [MetArt.abbreviation, MetArtX.abbreviation],
      assetsDirectory: 'playboy-coproduction-set-3',
      assetsAspectRatios: {
        desktop: 959 / 140,
        mobile_hor: 611 / 102,
        mobile_ver: 300 / 149,
        tablet: 959 / 140,
      },
    },
    {
      categoryName: 'redgifs-promo',
      sitesToDisplay: [SexArt.abbreviation],
      assetsDirectory: 'redgifs-promo',
      assetsAspectRatios: {
        desktop: 959 / 140,
        mobile_hor: 620 / 91,
        mobile_ver: 346 / 180,
        tablet: 959 / 140,
      },
      whitelistedPartnerIDs: [8107],
    },
    // {
    //   assetsDirectory: 'rylsky-promo',
    //   assetsAspectRatios: {
    //     desktop: 959 / 140,
    //     mobile_hor: 611 / 102,
    //     mobile_ver: 300 / 149,
    //     tablet: 959 / 140,
    //   },
    //   categoryName: 'rylsky-promo',
    //   sitesToHide: [RylskyArt.abbreviation],
    //   UUID: PhotographerUUIDS.Rylsky,
    // },
    // {
    //   assetsDirectory: 'ed-promo',
    //   assetsAspectRatios: {
    //     desktop: 959 / 140,
    //     mobile_hor: 611 / 102,
    //     mobile_ver: 300 / 149,
    //     tablet: 959 / 140,
    //   },
    //   categoryName: 'ed-promo',
    //   sitesToHide: [EternalDesire.abbreviation],
    //   UUID: PhotographerUUIDS.Arkisi,
    // },
    {
      assetsDirectory: 'goddessme-promo',
      assetsAspectRatios: {
        desktop: 959 / 140,
        mobile_hor: 611 / 102,
        mobile_ver: 300 / 149,
        tablet: 959 / 140,
      },
      categoryName: 'goddessme-promo',
      url: 'https://goddess.me/',
    },
    {
      assetsDirectory: 'sheseducedme-promo',
      assetsAspectRatios: {
        desktop: 959 / 140,
        mobile_hor: 605 / 104,
        mobile_ver: 300 / 149,
        tablet: 959 / 140,
      },
      categoryName: 'sheseducedme-promo',
      url: 'https://join.sheseducedme.com/track/MTMyLjEzLjEuMy4wLjAuMC4wLjA',
    },
    {
      assetsDirectory: 'virtualrealporn-promo',
      assetsAspectRatios: {
        desktop: 959 / 140,
        mobile_hor: 605 / 104,
        mobile_ver: 300 / 149,
        tablet: 959 / 140,
      },
      categoryName: 'virtualrealporn-promo',
      url: 'https://join.virtualrealporn.com/track/OTk5MTAzNTQuNS44LjEwLjUuMC4wLjAuMA',
    },
  ],
  getCategoryConfig: (galleryCategories?: GalleryCategories[]): PromoCategoryConfig | undefined => {
    return promoCategoriesConfig?.categories.find((configCategory) =>
      galleryCategories?.some((galleryCategory) => galleryCategory.name === configCategory.categoryName),
    );
  },
};
